import {
  AddShowingRequest,
  ShowingCollectionResponse,
  ShowingConnectionsResponse,
  ShowingDetails
} from '../models/api';
import { deleteData, getData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (
  sessionReference: string
): Promise<ResponseData<ShowingCollectionResponse>> =>
  getData<ShowingCollectionResponse>(
    `api/sessions/${sessionReference}/showings`
  );
export const add = async (
  sessionReference: string,
  model: AddShowingRequest
): Promise<ResponseData<ShowingDetails>> =>
  postData<ShowingDetails>(`api/sessions/${sessionReference}/showings`, model);
export const update = async (
  sessionReference: string,
  showingReference: string,
  model: AddShowingRequest
): Promise<ResponseData<ShowingDetails>> =>
  putData<ShowingDetails>(
    `api/sessions/${sessionReference}/showings/${showingReference}`,
    model
  );
export const get = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ShowingDetails>> =>
  getData<ShowingDetails>(
    `api/sessions/${sessionReference}/showings/${showingReference}`
  );
export const close = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ShowingDetails>> =>
  postData<ShowingDetails>(
    `api/sessions/${sessionReference}/showings/${showingReference}/close`,
    {}
  );
export const open = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ShowingDetails>> =>
  postData<ShowingDetails>(
    `api/sessions/${sessionReference}/showings/${showingReference}/open`,
    {}
  );
export const start = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ShowingDetails>> =>
  postData<ShowingDetails>(
    `api/sessions/${sessionReference}/showings/${showingReference}/start`,
    {}
  );
export const remove = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/sessions/${sessionReference}/showings/${showingReference}`);

export const getConnectionData = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ShowingConnectionsResponse>> =>
  getData<ShowingConnectionsResponse>(
    `api/sessions/${sessionReference}/showings/${showingReference}/Connections`
  );
